import { ContentType } from '@candu-ai/content/types';
import { ContentPlacement, SelectorLocation } from '@candu-ai/placement/types';

/**
 * Sets up the target element for a selector
 * @param root
 * @param element
 * @param placement
 */
export const createTargetElementForSelector = (
  root: HTMLElement,
  element: HTMLElement,
  placement: ContentPlacement,
) => {
  let cleanup = () => {
    root.remove();
  };
  const originalDisplay = element.style.display;
  if (placement.type === ContentType.Modal) {
    root.setAttribute('data-candu-modal', '');
    document.body.appendChild(root);
    return { cleanup, isModal: true };
  }

  switch (placement.location ?? SelectorLocation.START) {
    case SelectorLocation.REPLACE:
      if (!element.parentNode) {
        break;
      }
      element.parentNode.insertBefore(root, element);
      // eslint-disable-next-line no-param-reassign
      element.style.display = 'none';
      cleanup = () => {
        root.remove();
        // eslint-disable-next-line no-param-reassign
        element.style.display = originalDisplay;
      };
      break;

    case SelectorLocation.START:
      element.prepend(root);
      break;

    case SelectorLocation.END:
    default:
      element.append(root);
      break;
  }

  return { cleanup };
};
